import { Factory } from 'miragejs'
import { isEmpty } from '@ember/utils'
import { faker } from '@faker-js/faker'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export default Factory.extend({
  name() {
    return faker.company.name()
  },

  code() {
    return faker.finance.currencyCode() // PYG, MYR, DZD etc
  },

  afterCreate(partner, server) {
    if (isEmpty(partner.partnerContactDetails)) {
      server.create('partner-contact-detail', { subscriptionType: SubscriptionType.Reading, partner })
      server.create('partner-contact-detail', { subscriptionType: SubscriptionType.Maths, partner })
      server.create('partner-contact-detail', { subscriptionType: SubscriptionType.Writing, partner })
    }
  },
})
